import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, Skeleton} from 'views/components';

import DomainGuideCard from '../card/DomainGuideCard';

const DomainGuideColumn = (props) => {
  const {
    createdByLabelsByRn,
    domainGuides,
    isLoading,
    title,
  } = props;

  return (
    <Stack
      sx={{
        flex: '1 0 280px',
        minWidth: 280,
        backgroundColor: '#F8F6F3',
        border: '1px solid #E8E4DE',
        borderRadius: '8px',
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          borderBottom: '1px solid #E8E4DE',
        }}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 600,
            color: '#1A1916',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: 1.5,
          p: 1.5,
        }}
      >
        {
          !isLoading &&
          domainGuides.map((domainGuideData, index) => (
            <DomainGuideCard
              key={`${domainGuideData.domainGuideRn || 'domain-guide'}-${domainGuideData.createdAt || 'created-at'}-${index}`}
              domainGuideData={domainGuideData}
              createdByLabel={createdByLabelsByRn[domainGuideData.createdBy]}
            />
          ))
        }
        {
          isLoading &&
          <>
            <Skeleton variant="rounded" height={200} />
            <Skeleton variant="rounded" height={200} />
            <Skeleton variant="rounded" height={200} />
            <Skeleton variant="rounded" height={200} />
          </>
        }
      </Box>
    </Stack>
  );
};

DomainGuideColumn.propTypes = {
  createdByLabelsByRn: PropTypes.object.isRequired,
  domainGuides: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default React.memo(DomainGuideColumn);
